import { LinkButton } from '@cian/ui-kit';
import * as React from 'react';
import { IKPSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

import * as styles from './KpInfo.css';
import { KP_CLASSES_MAP } from './constants';
import { OfferSummaryInfoItem } from '../OfferSummaryInfo';

export interface IKpInfoProps extends IKPSchema {
  genplan: React.JSX.Element | null;
  onAboutKPButtonClick(): void;
}

export const KpInfo: React.FC<React.PropsWithChildren<IKpInfoProps>> = ({
  villageClass,
  counterSet,
  genplan,
  url,
  onAboutKPButtonClick,
}) => {
  return (
    <div>
      <div className={styles['container']}>
        <div className={styles['info']}>
          <OfferSummaryInfoItem name="Класс" value={KP_CLASSES_MAP[villageClass]} />
          <OfferSummaryInfoItem name="Всего объектов" value={counterSet.total} />
          <OfferSummaryInfoItem name="Объектов в продаже" value={counterSet.onSale} />
        </div>
        {genplan && <div className={styles['genplan']}>{genplan}</div>}
      </div>
      <div className={styles['about-button']}>
        <LinkButton href={url} onClick={onAboutKPButtonClick} target="_blank" size="XS" theme="stroke_primary">
          Подробнее о посёлке
        </LinkButton>
      </div>
    </div>
  );
};
